
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from './services/admin.service';
import { AuthenticationService } from './services/authentication.service';
import { OrganizationService } from './services/organization.service';
import { UserService } from './services/user.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  public isUser = false;
  public isOrg = false;

  title = "HopeEventsApp";
  signedIn = false;

  constructor(private authService: AuthenticationService, private router: Router, private orgService: OrganizationService,
    private userService: UserService) {
    setTimeout(() => this.signedIn = authService.checkIfSignedIn(), 2000)
  }

  ngOnInit() {
    setTimeout(() => this.isUser = this.userService.getUserStatus(), 2000)
    setTimeout(() => this.isOrg = this.orgService.getOrgStatus(), 2000)

  }

  SignOut() {
    this.signedIn = false;
    this.authService.SignOut();
    this.router.navigate(['login']);
  }
}